import React from 'react';
import PropTypes from 'prop-types';
import { isType } from '../../../../utils/react-children-utils/react-children-utils';
import styles from './styles.scss';

const ActionBar = function ActionBar(props) {
    const { children } = props;

    const wrapped = React.Children.toArray(children).map((c) => {
        let action = c;
        if (isType(c, 'LinkButtonA')) {
            action = React.cloneElement(
                c,
                {
                    className: `${c.props.className} ${styles['action-icon']}`,
                    children: c.props.children,
                },
            );
        }

        return (
            <div className={styles.action} key={c.props.id}>
                {action}
            </div>
        );
    });

    return <div className={styles['action-bar']}>{wrapped}</div>;
};

ActionBar.propTypes = {
    children: PropTypes.node.isRequired,
};

ActionBar.defaultProps = {
};

export default ActionBar;
